import styled from 'styled-components/macro';
import { getFlex } from '../../styled/styleUtils';

export const TemplateSelectorWrapper = styled.section``;
export const TemplateSelectorToggle = styled.button`
  ${getFlex()};
  position: relative;
  text-transform: capitalize;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 7px;
  cursor: pointer;
  color: var(--color-primary);
  background-color: var(--gray-50);
  border: 2px solid var(--indigo-200);
  transition: background-color 250ms var(--ease-in-out-quad);
  i {
    position: absolute;
    right: 1rem;
    transition: transform 250ms var(--ease-in-out-quad),
      opacity 250ms var(--ease-in-out-quad);
  }
  .edit {
    opacity: 1;
    transform: scale(1);
  }
  .arrow {
    opacity: 0;
    transform: scale(0);
  }
  &:hover {
    background-color: var(--indigo-50);
    .arrow {
      opacity: 1;
      transform: scale(1);
    }
    .edit {
      opacity: 0;
      transform: scale(0);
    }
  }
`;

export const TemplateSelectorToggleBack = styled.button`
  position: relative;
  background: none;
  border: none;
  width: 100%;
  padding: 0.5rem;
  i {
    padding: 0.25rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    border-radius: 100px;
    cursor: pointer;
    color: var(--color-primary);
    background-color: var(--gray-50);
    border: 2px solid var(--indigo-200);
    transition: background-color 250ms var(--ease-in-out-quad);
    &:hover {
      background-color: var(--indigo-50);
    }
  }
`;
export const TemplateSelectorMenu = styled.div`
  ${getFlex('flex-start', 'flex-start')};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: var(--color-white);
  z-index: 1;
  flex-direction: column;
`;
export const TemplateSelectorListWrapper = styled.div`
  padding: 0.5rem;
  border-radius: 7px;
  margin: 2rem 0;
  border: 2px solid var(--gray-200);
  flex: 1;
  width: 100%;
  overflow-y: auto;
`;
export const TemplateSelectorList = styled.ul`
  text-transform: capitalize;
  div {
    font-weight: 600;
  }
  li {
    line-height: 1.8;
  }
`;
export const TemplateListWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
  border-radius: 10px;
`;
